import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import React from 'react'
import { useWatch } from 'react-hook-form'
import { ACTIVE_POWER_FUNCTION_MODEL } from '../../types/common'
import { ActivePowerSettingsModel } from '../../types/grid-and-system-protection.model'
import { ActivePowerSettingsForm } from '../../types/schemas'
import ActivePowerSettingsTableRow from './ActivePowerSettingsTableRow'
import { NAME_SPACE } from './constants'

const ActivePowerSettingsTable: React.FC<{ activePowerSettingsModel: ActivePowerSettingsModel }> = ({ activePowerSettingsModel }) => {
  const { t } = useCustomTranslation()
  const selectedFunction: ACTIVE_POWER_FUNCTION_MODEL = useWatch({ name: 'selectedFunction' }) || ACTIVE_POWER_FUNCTION_MODEL.typeA
  const allFulcrums: ActivePowerSettingsForm['fulcrums'] = useWatch({ name: 'fulcrums' })
  const tableHeaderKey =
    selectedFunction === ACTIVE_POWER_FUNCTION_MODEL.typeB ? ACTIVE_POWER_FUNCTION_MODEL.typeB : ACTIVE_POWER_FUNCTION_MODEL.typeA

  const selectedFulcrums = allFulcrums?.[selectedFunction] || []
  const tableHeaderValues = tableHeaderConfig[tableHeaderKey]

  if (selectedFulcrums.length === 0) return null
  return (
    <TableContainer key={selectedFunction}>
      <Table
        sx={theme => ({
          border: 'none',
          '& td, & th': {
            border: 'none',
            padding: 1,
          },
          '& tbody tr, & thead tr': {
            border: 'none',
          },

          [theme.breakpoints.down('sm')]: {
            tableLayout: 'fixed',
          },
        })}
      >
        <TableHead>
          <TableRow>
            <TableCell align="left">{t(`${NAME_SPACE}.fulcrums.header.fulcrum`)}</TableCell>
            <TableCell align="left">{tableHeaderValues.secondColumn}</TableCell>
            <TableCell align="left">{tableHeaderValues.thirdColumn}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {selectedFulcrums.map((fulcrum, index) => (
            <ActivePowerSettingsTableRow
              key={index}
              index={index}
              selectedFunction={selectedFunction}
              fulcrum={fulcrum}
              fulcrums={activePowerSettingsModel.fulcrums}
            />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default ActivePowerSettingsTable

const tableHeaderConfig = {
  [ACTIVE_POWER_FUNCTION_MODEL.typeA]: {
    secondColumn: 'U/Un',
    thirdColumn: 'P/Pn',
  },
  [ACTIVE_POWER_FUNCTION_MODEL.typeB]: {
    secondColumn: 'U/Un',
    thirdColumn: 'ΔP / P_Knick',
  },
}
